import React, { useMemo, useState } from 'react';
import { BET_ACTION_MODAL_TYPE } from '../../../enums/betActionModal';
import { Statistic } from '../../statistics';
import { FavoriteBets } from '../../favoriteBets';
import { ReBet } from '../../autoBet';
import { autoBetStore } from '../../../store/autoBetStore';
import { observer } from 'mobx-react-lite';
import { useApplicationStore } from '@pascal/pascal-core';
import { gameStore } from '../../../store/gameStore';

export const OptionalBet = observer(() => {
  const { isDemo } = useApplicationStore();
  const { autoBetModel } = autoBetStore;
  const { isShowAutoPlay } = gameStore;
  const [isShowBetActionModal, setIsShowBetActionModal] = useState(null);

  const BetActionModal = useMemo(() => {
    const Components = {
      [BET_ACTION_MODAL_TYPE.statistics]: Statistic,
      [BET_ACTION_MODAL_TYPE.favoriteBets]: FavoriteBets,
      [BET_ACTION_MODAL_TYPE.reBet]: ReBet,
    };
    if (isShowBetActionModal) {
      return Components[isShowBetActionModal];
    }
    return null;
  }, [isShowBetActionModal]);

  const count = autoBetModel ? autoBetModel.autoBetCount + 1 : '';

  const handleShowPopup = (type) => {
    setIsShowBetActionModal(isShowBetActionModal === type ? null : type);
  };

  return (
    <>
      {BetActionModal && <BetActionModal setIsShowBetActionModal={setIsShowBetActionModal} />}

      <div
        className={`mob-roulette-t-icon-item statistics ${
          isShowBetActionModal === BET_ACTION_MODAL_TYPE.statistics ? 'active ' : ''
        }`}
        onClick={() => handleShowPopup(BET_ACTION_MODAL_TYPE.statistics)}
      >
        <i className='icon-statistics' />
      </div>
      <div
        className={`mob-roulette-t-icon-item favorite ${isDemo ? 'disabled' : ''} ${
          isShowBetActionModal === BET_ACTION_MODAL_TYPE.favoriteBets ? 'active ' : ''
        } `}
        onClick={() => handleShowPopup(BET_ACTION_MODAL_TYPE.favoriteBets)}
      >
        <i className='icon-star' />
      </div>
      {
        isShowAutoPlay && (
        <div
          className={`mob-roulette-t-icon-item replay ${
            isShowBetActionModal === BET_ACTION_MODAL_TYPE.reBet ? 'active' : ''
          }`}
          onClick={() => handleShowPopup(BET_ACTION_MODAL_TYPE.reBet)}
        >
          {autoBetModel && <div className='mob-roulette-t-number'>{count}</div>}
          <i className='icon-autoplay' />
        </div>
        )
      }
    </>
  );
});
